import script from "./RecoveryPassView.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryPassView.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryPassView.vue?vue&type=style&index=0&id=0be03bd6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be03bd6"]])

export default __exports__